<div *ngIf="downloadOrAttachButtonList" fxLaout="column">
  <particle-multiple-button-editor class="m-b-20" [buttonsList]="downloadOrAttachButtonList"
                                   (buttonClick)="onDownloadOrAttach($event)"> </particle-multiple-button-editor>
  <div *ngIf="selectedExportOptions.Footer && selectedExportOptions.Footer !=='' && hasMergedItem" class="blue-box-container">
    <strong>Please note: </strong><span></span> <span>{{selectedExportOptions.Footer}} <b>{{XmlMergeCountrySupport}}</b>.</span>
  </div>
</div>
